import axios, { AxiosResponse } from "axios";
import { Customer } from "@/models/customer/customer";
import { AuthError, APIError } from "@/services/error_service";
import { AppHeaders } from "@/models/api/api";

/**
 * Creates a new Customer Service

 * @example
 * const customerService = new CustomerService();
 * customerService.getCustomers();
 */

axios.defaults.withCredentials = true;
axios.defaults.headers = { apikey: process.env.VUE_APP_API_KEY } as AppHeaders;
axios.defaults.baseURL = process.env.VUE_APP_API_NODE_URL;

export default class CustomerService {
  /**
   * @returns {Customer[]} - response array of customer data objects
   */
  public async getCurrentCustomers(): Promise<Customer[]> {
    let customers;
    const url = "/customers?status=current";
    try {
      const options = {
        withCredentials: true
      };
      const res: AxiosResponse<any> = await axios.get(url, options);
      customers = res.data.data;
    } catch (err) {
      if (err.response.status && err.response.status != 500) {
        if (err.response.status === 401) {
          throw new AuthError(err.response, 401);
        } else if (err.response.status === 404) {
          throw new APIError("The requested information was not found.", 404);
        } else if (err.response.status === 403) {
          throw new APIError(
            "You do not have access to the requested resource.",
            403
          );
        }
      } else {
        throw new Error("Something went wrong. Please try again.");
      }
    }
    return customers;
  }

  /**
   * Get selected single customer
   * @param {number} id - customer id
   * @returns {Customer} - selected customer data object
   */
  public async getSingleCustomer(id: string): Promise<Customer> {
    let customer;
    const options = {
      withCredentials: true
    };
    try {
      const res: AxiosResponse<any> = await axios.get(
        "/customers/" + id,
        options
      );
      customer = res.data.data;
    } catch (err) {
      if (err.response.status && err.response.status != 500) {
        if (err.response.status === 401) {
          throw new AuthError(err.response, 401);
        } else if (err.response.status === 404) {
          throw new APIError("The requested information was not found.", 404);
        } else if (err.response.status === 403) {
          throw new APIError(
            "You do not have access to the requested resource.",
            403
          );
        }
      } else {
        throw new Error("Something went wrong. Please try again.");
      }
    }
    return customer;
  }
}
